import React from 'react';
import { useAppSelector } from '../data-services/store';
import StickyPrice from "../components/products-rel-docs/sticky-price";
import StickyAddToCart from "../components/products-rel-docs/sticky-add-to-cart";
import PRDPriceNote from "../components/products-rel-docs/prd-price-note";
import PRDGetAccess from "../components/products-rel-docs/prd-get-accesst";

/**
 * the entry point
 */
const AppMenuStickyRight: React.FC = () => {

    // test -----------
    const product = useAppSelector((store) => store.productsRelDocsInitialSelected);
    //const withCouponEnabled = product.couponCampaignID > 0;
    //const isWithCoupon = withCouponEnabled && product.couponPrice > 0;
    //const isSamePrice = product.msrp === product.skuPrice;


    const isProductNote = !product.skuEnabled && product.note !== null && product.note !== '';
    const isProductHide = !product.skuEnabled && product.addToCartStatus === 0 && product.note !== null && product.note === '';
    const isProductNoteDataSticky = isProductNote && product.note?.includes('data-sticky');
    //console.log(`isProductNote: ${isProductNote}, isProductHide: ${isProductHide}`);

    return (
        <div className="my-2 mr-4">

            {
                !product.isProductOptions  &&
                <>
                <div className="flex flex-row justify-end  items-center">
                    {!isProductHide && product.addToCartStatus === 0 && !isProductNote && <StickyPrice product={product} />}
                    {!isProductHide && product.addToCartStatus === 0 && !isProductNote && <StickyAddToCart product={product} />}
                    {!isProductHide && product.addToCartStatus > 0 && !isProductNote &&
                        <PRDGetAccess  product={product}
                                       classTryIt="text-gray-700"
                                       classEx="justify-end"
                                       classBtn="border"
                                       hideTryIt={true}
                                       showBadge={true}
                                       source="sticky"
                        />
                    }

                    {isProductNote && isProductNoteDataSticky && <PRDPriceNote product={product} classEx={"justify-end"} sourceCode={"sticky-menu"} />}
                </div>
                </>
            }

        </div>
    )
};

export default AppMenuStickyRight;